import { render, staticRenderFns } from "./dictItemAddOrUpdate.vue?vue&type=template&id=7f63b743&scoped=true&"
import script from "./dictItemAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./dictItemAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f63b743",
  null
  
)

export default component.exports